import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LogoComponent } from 'shared/components/logo/logo.component';

@Component({
  selector: 'app-single-layout',
  templateUrl: './single-layout.component.html',
  imports: [RouterOutlet, LogoComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col basis-full items-center p-8 gap-8'
  }
})
export class SingleLayoutComponent {
}
